import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels = {
  '/': 'Home',
  '/register': 'Registration',
  '/members': 'Members',
  '/admin': 'Admin',
  '/donation': 'Donation',
  '/rules': 'Club Rules',
  '/payment/success': 'Payment Success',
  '/payment/failure': 'Payment Failed',
  '/duty-manager': 'Duty Rota',
  '/members': 'Members Area'
};

const Breadcrumbs = ({ customLabel, parents }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const buildPath = (index) => {
    return '/' + pathnames.slice(0, index + 1).join('/');
  };

  const getLabel = (path) => {
    if (customLabel && path === location.pathname) {
      return customLabel;
    }
    return routeLabels[path] || path.charAt(0).toUpperCase() + path.slice(1);
  };

  const linkStyle = {
    textDecoration: 'none',
    color: '#0d2c54',
    fontFamily: "'General Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 500,
    transition: 'color 0.2s'
  };

  return (
    <MuiBreadcrumbs
      separator={<ChevronRight size={14} style={{ color: '#9ca3af' }} />}
      sx={{
        marginBottom: '24px',
        '& .MuiBreadcrumbs-ol': {
          flexWrap: 'nowrap'
        }
      }}
    >
      <Link
        to="/"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          ...linkStyle
        }}
        onMouseEnter={(e) => e.target.style.color = '#1a4a8a'}
        onMouseLeave={(e) => e.target.style.color = '#0d2c54'}
      >
        <Home size={16} />
        Home
      </Link>

      {parents && parents.map((p) => (
        <Link
          key={p.path}
          to={p.path}
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.color = '#1a4a8a'}
          onMouseLeave={(e) => e.target.style.color = '#0d2c54'}
        >
          {p.label}
        </Link>
      ))}

      {pathnames.map((value, index) => {
        const path = buildPath(index);
        const isLast = index === pathnames.length - 1;
        const label = getLabel(path);

        return isLast ? (
          <Typography
            key={path}
            sx={{
              fontFamily: "'General Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 500,
              color: '#6b7280'
            }}
          >
            {label}
          </Typography>
        ) : (
          <Link
            key={path}
            to={path}
            style={linkStyle}
            onMouseEnter={(e) => e.target.style.color = '#1a4a8a'}
            onMouseLeave={(e) => e.target.style.color = '#0d2c54'}
          >
            {label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
